var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRightDown = function SvgIconRightDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 5a1 1 0 0 0 0 2h12.5v10.086l-2.793-2.793a1 1 0 0 0-1.414 1.414l4.5 4.5.007.007a1 1 0 0 0 .697.286h.006a1 1 0 0 0 .705-.294l4.5-4.499a1 1 0 0 0-1.415-1.414L17.5 17.086V6a1 1 0 0 0-1-1z"
  })));
};
export default SvgIconRightDown;